import * as React from "react";
import PropTypes from "prop-types";
import {
    Card,
    CardActionArea,
    CardContent,
    Box,
    Typography,
} from "@mui/material";
import { Download, FlightTakeoff } from "@mui/icons-material";

/**
 * CardVuelo
 * @param {object} props
 * @param {{id:string|number, destino:string, horaSalida:string, fechaSalida:string}} props.flight
 * @param {(flight:object)=>void} props.onDownload  // se llama al hacer click
 * @param {object} [props.sx]                          // sx opcional para custom styles
 * @param {React.ReactNode} [props.actions]            // slot opcional para acciones extra
 */
export default function CardVuelo({ flight, onDownload, sx, actions }) {
    const timeLabel = flight?.horaSalida || "";
    const timeZoneLabel = flight?.timeZoneLabel || "";
    return (
        <Card
            sx={{
                bgcolor: "white",
                boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                "&:hover": { boxShadow: "0 4px 12px rgba(0,0,0,0.15)" },
                ...sx,
            }}
        >
            <CardActionArea
                onClick={() => onDownload?.(flight)}
                sx={{ cursor: "pointer" }}
            >
                <CardContent>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                                variant="h6"
                                sx={{ fontWeight: 700, color: "#2a8fa6", mb: 0.5 }}
                            >
                                Vuelo {flight?.id}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{ fontWeight: 600, mb: 1 }}
                            >
                                {flight?.destino}
                            </Typography>

                            <Box
                                sx={{
                                    display: "flex",
                                    gap: 3,
                                    flexWrap: "wrap",
                                    alignItems: "center",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 28,
                                            height: 28,
                                            borderRadius: "50%",
                                            bgcolor: "#3baec7",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexShrink: 0,
                                        }}
                                    >
                                        <FlightTakeoff
                                            sx={{ fontSize: 16, color: "white" }}
                                        />
                                    </Box>
                                    <Box>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            display="block"
                                        >
                                            Salida
                                        </Typography>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontWeight: 700,
                                                lineHeight: 1.2,
                                                display: "inline-flex",
                                                alignItems: "baseline",
                                                gap: 0.75,
                                            }}
                                        >
                                            <span>{timeLabel}</span>
                                            {timeZoneLabel && (
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        color: "text.secondary",
                                                        fontSize: "0.8rem",
                                                    }}
                                                >
                                                    ({timeZoneLabel})
                                                </Box>
                                            )}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>

                        <Box
                            sx={{
                                width: 36,
                                height: 36,
                                borderRadius: "50%",
                                bgcolor: "#3baec7",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                            }}
                        >
                            <Download sx={{ color: "white", fontSize: 18 }} />
                        </Box>

                        {/* Acciones extra opcionales */}
                        {actions}
                    </Box>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}

CardVuelo.propTypes = {
    flight: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            .isRequired,
        destino: PropTypes.string.isRequired,
        horaSalida: PropTypes.string.isRequired,
        fechaSalida: PropTypes.string,
        timeZoneLabel: PropTypes.string,
    }).isRequired,
    onDownload: PropTypes.func, // (id) => void
    sx: PropTypes.object,
    actions: PropTypes.node,
};
